<template>
  <div class="form">
    <!--begin::Content header-->

    <!--end::Content header-->
    <!--begin::Form-->
    <div class="instructions">
      <div class="instructions-content">
        <h3>Bienvenido al nuevo portal <img :src="images.logo" /></h3>
        <p>
          Aquí podrás encontrar toda la información de tu proceso de compra, el
          estado de tus solicitudes y mucho más.
        </p>
        
        <p>
          Espere un momento. Estamos ingresando a su portal
        </p>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.instructions {
  width: 100%;
  padding: 20px;
  .instructions-content {
    display: grid;
    row-gap: 10px;
    h3 {
      font-size: 20px;
      font-weight: bold;
      color: var(--bricsa-grey);
      img {
        width: 150px;
        @media screen and (max-width: 1024px) {
          width: 80px;
        }
      }
    }
    .steps {
      padding: 20px 30px;
      background: #eaeaea;
      ul {
        list-style-type: disc;
        display: grid;
        row-gap: 10px;
        li {
          span {
            color: var(--bricsa-red);
          }
          img {
            margin-left: 5px;
            width: 100px;
          }
        }
      }
    }
  }
}
.spinner.spinner-right {
  padding-right: 3.5rem !important;
}
.recovery-btn {
  color: #252525;
  transition: 200ms;
  &:hover {
    color: #0a2188;
  }
}
</style>

<script>
import { mapState } from "vuex";
import { VERIFY_AUTH } from "@/core/services/store/auth.module";
import { rutEsValido } from "@/core/validators/rut.js";
import JwtService from "@/core/services/jwt.service";
import RoleService from "@/core/services/role.service";
import { validationMixin } from "vuelidate";
import { minLength, required } from "vuelidate/lib/validators";

export default {
  mixins: [validationMixin],
  name: "loginExt",
  data() {
    return {
      // Remove this dummy login info
      form: {
        rut: "",
        password: "",
      },
      images: {
        logo: process.env.BASE_URL + "./media/logo.png",
      },
    };
  },
  mounted() {
    JwtService.destroyToken();
    this.validateToken();
  },
  validations: {
    form: {
      rut: {
        required,
        rutEsValido,
      },
      password: {
        required,
        minLength: minLength(3),
      },
    },
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    resetForm() {
      this.form = {
        rut: null,
        password: null,
      };

      this.$nextTick(() => {
        this.$v.$reset();
      });
    },
    validateToken(){
      const token = this.$route.params.token;
      if(typeof token!='undefined'){
        JwtService.saveToken(token);
        RoleService.saveRole("Cliente");
        this.$store
          .dispatch(VERIFY_AUTH)
          .then(() => {
              this.$router.push({ name: "dashboard" });
          })
          .catch(() => {});
        }
    },
  },
  computed: {
    ...mapState({
      errors: (state) => state.auth.errors,
    }),
  },
};
</script>
